import { IComponentConfig } from "@/app/@types/base-component";
import { ReactiveComponent } from "./base-component";

export type ExtraItemConfig = IComponentConfig & {
    discount: boolean;
};

export class ExtraItem extends ReactiveComponent {
    public discount: boolean = false;

    constructor(config: ExtraItemConfig) {
        super({ ...config, type: "extra-item" });
        this.discount = !!config.discount;
    }
}

export class Extra extends ReactiveComponent {
    constructor(config: IComponentConfig) {
        super({ ...config, type: "extra" });
    }

    getExtraItems = () => {
        return this.components.filter(
            (component) => component.type === "extra-item",
        );
    };
}
